import { SITE_URL } from '../../constants'
import { buildCaseStudySchema } from '../../builders/caseStudy'
import { PageMeta } from '../../types'

const description = "イノベーション案を創出するワークショップを実施しました。このワークショップは参加者の思考の枠を外すことを重視し、スペキュラティブデザイン思考と破壊的イノベーションフレームワークを取り入れました。最終的には3by3ビジネスフレームを用いて、イノベーション案の創出支援を実施しました。"

const ogpImg = "https://aitria.co.jp/images/img/cases/jfe/ogp_jfe.png"

export const jfePageMeta: PageMeta = {
  title: "DX-DAY アイデアソン | 事例 | Aitria（アイトリア）",
  description,
  keyword: "DX戦略 組織開発 人材育成 生成AI デジタルトランスフォーメーション",
  image: ogpImg,
  url: `${SITE_URL}/cases/jfe/`,
}

export const jfeSchema = buildCaseStudySchema({
  slug: "jfe",
  pageTitle: jfePageMeta.title,
  description: jfePageMeta.description,
  headline: "DX-DAY アイデアソン",
  alternativeHeadline: "JFE エンジニアリング株式会社",
  primaryImage: ogpImg,
  images: [ogpImg,"https://aitria.co.jp/images/img/cases/caseStudyTop/jfe.webp"],
  clientName: "JFE エンジニアリング株式会社",
  breadcrumbLabel: "DX-DAY アイデアソン",
})
